module.exports = __webpack_public_path__ + "static/media/01C.d7452e4b.png";